import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { IsFunctionPipe, IsStringPipe } from '@pct-ng/common/pipe';
import { RouterLink } from '@angular/router';
import type { MenuItem } from './main-menu-config.type';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { ResolveTranslateAbleTextPipe } from '@pct-ng/i18n';
import type { AdminUserRole } from '@cappus/shared-common';

@Component({
  selector: 'szg-feature-app-layout-ui-menu',
  imports: [
    MatMenu,
    MatButton,
    MatIcon,
    MatMenuTrigger,
    IsFunctionPipe,
    IsStringPipe,
    MatMenuItem,
    RouterLink,
    MatMenuContent,
    CustomMatSvgIconDirective,
    ResolveTranslateAbleTextPipe,
  ],
  templateUrl: './menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  readonly mainLabelText = input.required<string>();
  readonly items = input.required<MenuItem<AdminUserRole>[]>();
}
